import { reportingCoreModule } from '@dynameat/views/reporting/module';
import * as actions from './actions';

export const reportingModule = {
  actions,
  modules: {
    reportingCoreModule
  }
};
